/**
 * @module app.fm
 */

import { FrameworkConfiguration } from 'aurelia-framework';
import { FaxManagementModule } from './module';

export function configure(config: FrameworkConfiguration) {
    config
        .singleton(FaxManagementModule.registrationKey, FaxManagementModule);

    config.globalResources([
        // elements

        // value converters
    ]);
}
